import { useEffect, useRef, useState } from 'react';

/**
 * Measures the rendered width of an element and keeps it in sync with
 * window resizes, clamped to `maxWidth`. Useful for sizing embedded
 * third-party widgets (e.g. Google's Sign-In button) that only accept a
 * fixed pixel width rather than a percentage.
 *
 * @param {number} [maxWidth=Infinity]
 * @returns {{ ref: import('react').RefObject, width: number }}
 */
export const useMeasuredWidth = (maxWidth = Infinity) => {
  const ref = useRef(null);
  const [width, setWidth] = useState(maxWidth);

  useEffect(() => {
    const measure = () => {
      const measured = ref.current?.offsetWidth;
      if (measured) setWidth(Math.min(measured, maxWidth));
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [maxWidth]);

  return { ref, width };
};
